module.exports = ":host .value-input {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 4px;\n  margin-bottom: 0; }\n\n:host .card {\n  border-radius: 8px; }\n\n:host .card-body {\n  height: 180px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/find-criteria/find-criteria.component.scss
// module id = ./src/app/shared/find-criteria/find-criteria.component.scss
// module chunks = main